import React, { memo } from 'react'

import { withLayout } from '@smartcoop/web-containers/layouts'
import StampScreen from '@smartcoop/web-containers/screens/guest/StampScreen'

const AuthenticatedStamp = (props) => <StampScreen { ...props } />

export default memo(withLayout('guest')(AuthenticatedStamp))
